module.exports = __webpack_public_path__ + "static/media/Stellar Vox Queen Headboard - 155 cm_Light Beige.cc100fd0.png";